/**
 * トーストメッセージで使用する通知の種類の定義
 */
export const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
} as const;

/**
 * トーストメッセージ用Enum
 */
export const MESSAGES = {
  SUCCESS: {
    SAVE: 'データを保存しました。',
    UPDATE: 'データを更新しました。',
    DELETE: '削除が完了しました。',
  },
  ERROR: {
    SAVE: 'データの保存に失敗しました。',
    UPDATE: 'データの更新に失敗しました。',
    FETCH: 'データの取得に失敗しました。',
    AUTH: 'ログインが必要です。',
    LOGIN: 'ログインできませんでした。',
  },
  INFO: {
    LOGIN: 'ログインしました。',
    LOGOUT: 'ログアウトしました。',
  },
} as const;
